module.exports = __webpack_public_path__ + "img/icon-85.bdea2128.png";